import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { BuyersReportInfo } from "../../../SchemaInfo/info";
import { ReportBuyerSchema } from "../../../Schemas/buyers/report_schema";
import { Form, Formik } from "formik";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import Stars from "react-stars";
import { useSelector } from "react-redux";
import { RiContractLine } from "react-icons/ri";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const LtcBuyerTable = ({
  buyers,
  favBuyer,
  userId,
  refresh,
  setRefresh,
  filters,
}) => {
  const employee = useSelector((store) => store.login.user);
  const [modalData, setModalData] = useState("");
  const navigate = useNavigate();
  const [id, setId] = useState();

  const handleCardClick = (buyer) => {
    navigate(`/buyers-management/view/${buyer.id}`);
  };

  const handelSubmit = (values, actions) => {
    let closeModel = document.getElementById("close-model");
    performRequest(
      "PATCH",
      `/buyerProfiles/updatebuyerProfiles/${modalData?.id}`,
      values
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Your response recorded successfully!");
          closeModel.click();
          actions.resetForm();
        } else {
          Toast("error", "Error while updating");
          closeModel.click();
          actions.resetForm();
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
        closeModel.click();
        actions.resetForm();
      });
  };

  const [paymentRating, setPaymentRating] = useState(0);
  const [availabilityRating, setAvailabilityRating] = useState(0);
  const [repetitionRating, setRepetitionRating] = useState(0);

  const roundToOneDecimalPlace = (value) => {
    return parseFloat(value.toFixed(1));
  };

  const handleSaveChanges = (existingRating) => {
    if (+paymentRating && +availabilityRating && +repetitionRating > 0) {
      const averageRating =
        (+existingRating +
          +paymentRating * 2 +
          +availabilityRating * 2 +
          +repetitionRating * 2) /
        4;
      const roundedAverageRating = roundToOneDecimalPlace(averageRating);
      saveBuyerRating(roundedAverageRating);
    } else {
      navigate("/buyers-management");
    }
  };

  const saveBuyerRating = (averageRating) => {
    let values = {
      buyerRating: averageRating,
    };
    performRequest("PATCH", `/buyerProfiles/updatebuyerProfiles/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Rating submitted successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while updating");
          setRefresh(!refresh);
        }
        resetRatings();
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      });
  };
  const clampStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const clampStyle1 = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const resetRatings = () => {
    setPaymentRating(0);
    setAvailabilityRating(0);
    setRepetitionRating(0);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter card-table table-striped">
        <thead>
          <tr>
            <th>Crop</th>
            <th style={{ maxWidth: "100px" }}>Buyer</th>
            {/* <th>Duration</th> */}
            <th>Contract Period</th>
            {/* <th>Pricing</th> */}

            {/* <th className="d-none d-md-table-cell">Market</th> */}
            <th>Agreement</th>
            {(employee.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
              employee.Role === process.env.REACT_APP_ROLE_ADMIN) && (
              <th>Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {buyers?.map((buyer) => (
            <tr key={buyer?.id}>
              <td>
                <div className="row">
                  <div className="col-12 col-md-auto d-flex align-items-start">
                    {buyer?.openForLtc && buyer?.cropPhoto && (
                      <img
                        src={buyer.cropPhoto}
                        alt="Crop"
                        style={{ width: 40, marginRight: 10 }}
                        className="img-fluid"
                      />
                    )}
                  </div>
                  <div className="col-12 col-md">
                    <strong style={clampStyle1}>
                      {buyer?.cropName?.toUpperCase() || "N/A"}
                    </strong>
                    <p className="mb-0">
                      ₹{buyer?.pricing ? buyer.pricing : "N/A"}/Kg
                    </p>
                  </div>
                </div>
              </td>

              <td style={{ maxWidth: "300px" }}>
                <strong>{buyer.name}</strong>
                <br />
                {buyer?.addressLine1 && buyer?.addressState ? (
                  <p style={clampStyle}>{buyer.addressLine1}</p>
                ) : (
                  "N/A"
                )}
              </td>
              <td>
                {buyer?.ltcDuration}
                {"  "} {buyer?.ltcDurationType}
                <br />
                {buyer?.purchaseQuantity
                  ? `${buyer?.purchaseQuantity} kg `
                  : ""}
                every {buyer?.purchaseFrequency}
                {"  "}
                {buyer?.purchaseFrequencyType}
              </td>
              <td>
                {!buyer?.orderOrigin && (
                  <>
                    <button
                      className="btn btn-sm px-3 btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#modal-scrollable"
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalData(buyer);
                        setId(buyer.id);
                      }}
                    >
                      <RiContractLine className="fs-3 me-1 d-none d-lg-block" />
                      Agreement
                    </button>

                    <div
                      className="modal modal-blur fade"
                      id="modal-scrollable"
                      tabIndex="-1"
                      role="dialog"
                      aria-hidden="true"
                    >
                      {/* your existing modal code */}
                      <div
                        className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Agreement</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <h4 className="modal-title text-center m-0">
                              CONTRACT FARMING AGREEMENT (DEMO CONTRACT)
                            </h4>
                            <p className="modal-subtitle text-center">
                              A Kryzen Biotech Private Limited has no
                              interference in said contract terms.
                            </p>
                            This Agreement is made on (“Effective Date”) between
                            ________________ , by and between{" "}
                            <strong>Buyer :</strong>{" "}
                            {modalData ? modalData.name : ""}, Address :
                            {modalData ? modalData.addressLine1 : ""},
                            {modalData ? modalData.addressState : ""},{" "}
                            {modalData ? modalData.pincode : ""}{" "}
                            <strong>Farmer :</strong> {employee.Name}
                            <hr />
                            <ol>
                              <li>
                                <strong>Duration of Agreement</strong>
                                <br />
                                This Agreement starts on [Start Date] and
                                continues until [End Date]. Either party can end
                                the Agreement earlier if they follow the proper
                                procedures outlined here.
                              </li>
                              <li>
                                <strong>Pricing of Produce</strong>
                                <br />
                                The price the Buyer will pay for the produce
                                depends on its quality (or "grade"). The grades
                                and their corresponding prices are as follows:
                                <ol type="a">
                                  <li>
                                    <strong>Grade A</strong>:{" "}
                                    {modalData?.pricing
                                      ? `₹${modalData?.pricing}/kg`
                                      : ""}
                                  </li>
                                  <li>
                                    <strong>Grade B</strong>:{" "}
                                    {modalData?.pricing
                                      ? `₹${(modalData?.pricing * 0.95).toFixed(
                                          2
                                        )}/kg`
                                      : ""}
                                  </li>
                                  <li>
                                    <strong>Grade C</strong>:{" "}
                                    {modalData?.pricing
                                      ? `₹${(modalData?.pricing * 0.9).toFixed(
                                          2
                                        )}/kg`
                                      : ""}
                                  </li>
                                </ol>
                              </li>
                              <li>
                                <strong>Maximum Supply Limit</strong>
                                <br />
                                The Farmer agrees not to supply more than
                                [Maximum Quantity] per square meter of land.
                                This helps to ensure that the produce is of the
                                highest quality.
                              </li>
                              <li>
                                <strong>Mobilization Time</strong>
                                <br />
                                The Farmer must start growing the crops within
                                [Number of Days] days after signing this
                                Agreement. If the Buyer needs to provide any
                                supplies or inputs, they will do so within
                                [Number of Days] days from the start date.
                              </li>
                              <li>
                                <strong>Payment Terms</strong>
                                <br />
                                Payments will be made as follows:
                                <ol type="a">
                                  <li>
                                    The Buyer will pay [Percentage]% of the
                                    total amount when the Farmer delivers the
                                    produce.
                                  </li>
                                  <li>
                                    The remaining [Percentage]% will be paid
                                    within [Number of Days] days after delivery,
                                    provided that the produce meets quality
                                    standards.
                                  </li>
                                </ol>
                              </li>
                              <li>
                                <strong>Late Delivery of Produce</strong>
                                <br />
                                If the Farmer delivers the produce late, they
                                will pay a penalty of [Percentage]% of the total
                                invoice amount for each day the delivery is
                                delayed.
                              </li>
                              <li>
                                <strong>Non-Delivery of Produce</strong>
                                <br />
                                If the Farmer does not deliver the produce, they
                                must compensate the Buyer for any additional
                                costs or losses, such as purchasing from other
                                suppliers.
                              </li>
                              <li>
                                <strong>Retention Clause</strong>
                                <br />
                                The Buyer will hold back 5% of the total payment
                                as a security deposit. This amount will be
                                released only after the Agreement has been fully
                                completed without any issues.
                              </li>
                              <li>
                                <strong>Packaging</strong>
                                <br />
                                The Farmer is responsible for making sure that
                                the produce is packaged properly to keep it
                                fresh and undamaged during transport.
                              </li>
                              <li>
                                <strong>Safety of Goods</strong>
                                <br />
                                The Farmer must take all necessary precautions
                                to ensure that the produce is safe and not
                                contaminated or damaged during growing,
                                packaging, and transport.
                              </li>
                              <li>
                                <strong>Insurance of Goods</strong>
                                <br />
                                The Farmer must have insurance coverage for the
                                produce from the time it is growing until it
                                reaches the Buyer. The Buyer should be listed as
                                an additional insured party on this policy.
                              </li>
                              <li>
                                <strong>Farmer Code of Conduct</strong>
                                <br />
                                The Farmer agrees to follow ethical farming
                                practices. This includes treating workers
                                fairly, protecting the environment, and
                                following local laws.
                              </li>
                              <li>
                                <strong>QEHSE Policy</strong>
                                <br />
                                The Farmer must comply with the Buyer's Quality,
                                Environmental, Health, Safety, and Environmental
                                (QEHSE) policies. These will be shared with the
                                Farmer as part of this Agreement.
                              </li>
                              <li>
                                <strong>Technical Details Sharing</strong>
                                <br />
                                The Farmer must provide all relevant technical
                                information about the produce. This includes
                                codes used for goods (HSN codes), the seed
                                company, and any labeling details required by
                                the Buyer.
                              </li>
                              <li>
                                <strong>Repacking of Goods</strong>
                                <br />
                                If the Buyer repacks the produce after receiving
                                it, the Farmer will not be responsible for any
                                loss of quality or damage that occurs during the
                                repacking process.
                              </li>
                              <li>
                                <strong>
                                  No Trace of Heavy Metal or Non-Permitted
                                  Substance
                                </strong>
                                <br />
                                The Farmer must ensure that the produce does not
                                contain any heavy metals or non-permitted
                                substances.
                              </li>
                              <li>
                                <strong>Law of India</strong>
                                <br />
                                This Agreement is governed by the laws of India.
                              </li>
                              <li>
                                <strong>Bills of Quantity (BOQ)</strong>
                                <br />
                                Every time the Farmer delivers produce, they
                                must provide a detailed list (Bill of Quantity)
                                that shows the price for each item.
                              </li>
                              <li>
                                <strong>Additional Equipment Required</strong>
                                <br />
                                If special equipment is needed to grow or
                                harvest the produce, the Farmer is responsible
                                for obtaining and maintaining this equipment.
                              </li>
                              <li>
                                <strong>No Guarantee of Employment</strong>
                                <br />
                                This Agreement does not create an employment
                                relationship between the Farmer and the Buyer.
                                The Farmer is an independent contractor.
                              </li>
                              <li>
                                <strong>
                                  No Partnership or Future Business Guarantee
                                </strong>
                                <br />
                                This Agreement does not mean that the Farmer and
                                Buyer are partners or that there will be future
                                business dealings beyond this Agreement.
                              </li>
                              <li>
                                <strong>Third-Party Inspection Agency</strong>
                                <br />A third-party inspection agency, agreed
                                upon by both parties, will inspect the produce
                                to ensure it meets quality standards.
                              </li>
                              <li>
                                <strong>
                                  Running Account Payments Clearance
                                </strong>
                                <br />
                                The Buyer agrees to clear any ongoing payments
                                within [Number of Days] days of receiving the
                                corresponding invoices.
                              </li>
                              <li>
                                <strong>Final Settlement</strong>
                                <br />
                                All payments, including any held back amounts,
                                will be settled once the Agreement is completed
                                successfully.
                              </li>
                              <li>
                                <strong>No Royalties</strong>
                                <br />
                                The Farmer will not receive any additional
                                payments, such as royalties, beyond the agreed
                                price for the produce.
                              </li>
                              <li>
                                <strong>Force Majeure</strong>
                                <br />
                                Neither the Farmer nor the Buyer will be
                                responsible for delays or failures to fulfill
                                their obligations if they are caused by events
                                beyond their control, such as natural disasters,
                                war, or government actions.
                              </li>
                              <li>
                                <strong>Acceptance and Rejection</strong>
                                <br />
                                The Buyer has the right to inspect the produce
                                and accept or reject it based on its quality. If
                                the produce is rejected, the Farmer must either
                                replace it or correct the issue at their own
                                cost.
                              </li>
                              <li>
                                <strong>Liquidated Damages</strong>
                                <br />
                                If either party br/eaches this Agreement, the
                                other party may be entitled to a specific amount
                                of compensation, known as liquidated damages.
                              </li>
                              <li>
                                <strong>
                                  Compliance with Laws and Regulations
                                </strong>
                                <br />
                                The Farmer agrees to follow all applicable laws,
                                site regulations, and Environmental, Social, and
                                Governance (ESG) requirements. 
                              </li>
                              <li>
                                <strong>
                                  Indemnity and Limitation of Liability
                                </strong>
                                <br />
                                The Farmer agrees to protect the Buyer from any
                                claims or damages arising from the Farmer’s
                                actions under this Agreement. The Buyer’s total
                                liability under this Agreement is limited to the
                                total amount paid to the Farmer.
                              </li>
                              <li>
                                <strong>
                                  Suspension and Termination of Contract 
                                </strong>
                                <br />
                                Either the Farmer or the Buyer can suspend or
                                end this Agreement by giving [Number of Days]
                                days' notice in writing to the other party.
                              </li>
                              <li>
                                <strong>Settlement of Disputes</strong>
                                <br />
                                If there is a disagreement, the Farmer and Buyer
                                should first try to resolve it through
                                discussion. If that fails, the dispute may go to
                                arbitration according to [Arbitration Rules].
                              </li>
                              <li>
                                <strong>Assignment and Subcontracting</strong>
                                <br />
                                The Farmer cannot pass on or subcontract any of
                                their obligations under this Agreement without
                                the Buyer’s written consent.
                              </li>
                              <li>
                                <strong>Non-Solicitation</strong>
                                <br />
                                The Farmer agrees not to approach or do business
                                with the Buyer’s clients, suppliers, or
                                employees during the term of this Agreement and
                                for [Number of Months] months after it ends.
                              </li>
                              <li>
                                <strong>Entire Agreement</strong>
                                <br />
                                This document represents the entire Agreement
                                between the Farmer and the Buyer. It replaces
                                any previous agreements, understandings, or
                                discussions, whether written or spoken.
                              </li>
                            </ol>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </td>
              {(employee.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                employee.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                <td>
                  <CustomViewButton
                    onClick={() => {
                      handleCardClick(buyer);
                    }}
                  ></CustomViewButton>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="row row-deck">
        {buyers.map((buyer) => (
          <div className="col-lg-6">
            <div
              className="modal modal-blur fade"
              id="modal-simple"
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Rate a buyer</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div
                        className="mb-3 d-flex"
                        style={{ alignItems: "center", gap: "1rem" }}
                      >
                        <div style={{ width: "130px" }}>
                          <label
                            className="form-label"
                            style={{ display: "block" }}
                          >
                            Payment on time
                          </label>
                        </div>
                        <div>
                          <Stars
                            count={5}
                            size={30}
                            value={paymentRating}
                            onChange={(newValue) => setPaymentRating(newValue)}
                          />
                        </div>
                      </div>
                      <div
                        className="mb-3 d-flex"
                        style={{ alignItems: "center", gap: "1rem" }}
                      >
                        <div style={{ width: "130px" }}>
                          <label
                            className="form-label"
                            style={{ display: "block" }}
                          >
                            Buyer availability
                          </label>
                        </div>
                        <div>
                          <Stars
                            count={5}
                            size={30}
                            value={availabilityRating}
                            onChange={(newValue) =>
                              setAvailabilityRating(newValue)
                            }
                          />
                        </div>
                      </div>
                      <div
                        className="mb-3 d-flex"
                        style={{ alignItems: "center", gap: "1rem" }}
                      >
                        <div style={{ width: "130px" }}>
                          <label
                            className="form-label"
                            style={{ display: "block" }}
                          >
                            Repetition of orders
                          </label>
                        </div>
                        <div>
                          <Stars
                            count={5}
                            size={30}
                            value={repetitionRating}
                            onChange={(newValue) =>
                              setRepetitionRating(newValue)
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer justify-content-between">
                    <div>
                      <b>Finding issues:</b>{" "}
                      <button
                        className="btn btn-danger p-1 ms-1"
                        data-bs-toggle="modal"
                        data-bs-target="#report-buyer"
                        style={{ width: "70px" }}
                      >
                        Report
                      </button>
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary p-1"
                      onClick={() => handleSaveChanges(buyer?.buyerRating)}
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{ width: "70px" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal modal-blur fade"
              id="report-buyer"
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Report Problem: {modalData ? modalData.name : ""}
                    </h5>
                    <button
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <Formik
                      initialValues={BuyersReportInfo}
                      validationSchema={ReportBuyerSchema}
                      onSubmit={handelSubmit}
                    >
                      {(props) => (
                        <Form>
                          <div className="card-body">
                            <div className="mb-3 w-100 col">
                              <div className="d-flex">
                                <label className=" form-check-inline  ">
                                  <CustomCheckbox
                                    type="checkbox"
                                    width={"18px"}
                                    height={"18px"}
                                    name="report"
                                    value="call not connected"
                                  />
                                </label>
                                <p className="form-check-label">
                                  Call Not Connected
                                </p>
                              </div>
                            </div>{" "}
                            <div className="mb-3 w-100 col">
                              <div className="d-flex">
                                <label className=" form-check-inline  ">
                                  <CustomCheckbox
                                    type="checkbox"
                                    width={"18px"}
                                    height={"18px"}
                                    name="report"
                                    value="wrong number"
                                  />
                                </label>
                                <p className="form-check-label">Wrong Number</p>
                              </div>
                            </div>{" "}
                            <div className="mb-3 w-100 col">
                              <div className="d-flex">
                                <label className=" form-check-inline  ">
                                  <CustomCheckbox
                                    type="checkbox"
                                    width={"18px"}
                                    height={"18px"}
                                    name="report"
                                    value="wrong buyer"
                                  />
                                </label>
                                <p className="form-check-label">Wrong Buyer</p>
                              </div>
                            </div>
                            <div className="mb-3 w-100 col">
                              <div className="d-flex">
                                <label className=" form-check-inline  ">
                                  <CustomCheckbox
                                    type="checkbox"
                                    width={"18px"}
                                    height={"18px"}
                                    name="report"
                                    value="not buying anymore"
                                  />
                                </label>
                                <p className="form-check-label">
                                  Not Buying Anymore
                                </p>
                              </div>

                              {props.touched.report && props.errors.report && (
                                <p className="text-danger">
                                  {props.errors.report}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="modal-footer d-flex justify-content-between">
                            <div>
                              <button
                                data-bs-toggle="modal"
                                data-bs-target="#modal-simple"
                                className="btn btn-primary m-2 p-1"
                                style={{ width: "70px" }}
                              >
                                Back
                              </button>
                            </div>
                            <div>
                              <button
                                type="submit"
                                className={`btn btn-danger m-2 p-1`}
                                buttonText="Report"
                                data-bs-dismiss="modal"
                                style={{ width: "70px" }}
                              >
                                Report
                              </button>

                              <button
                                type="button"
                                id="close-model"
                                className={`btn btn-secondary p-1`}
                                buttonText="Cancel"
                                data-bs-dismiss="modal"
                                style={{ width: "70px" }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LtcBuyerTable;
